import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { OcbHttpVerbs } from '@app/core';
import { DxSelectBoxComponent } from 'devextreme-angular/ui/select-box';

@Component({
    selector: 'app-http-verb-picker',
    templateUrl: './http-verb-picker.component.html',
    styleUrls: ['./http-verb-picker.component.scss'],
})
export class HttpVerbPickerComponent {

    @Input()
    public selectedItem: string;

    @Input()
    public readonly: boolean = false;

    @Output()
    public selectedItemChange = new EventEmitter<string>();

    @ViewChild(DxSelectBoxComponent)
    public selectBox: DxSelectBoxComponent;

    public verbs: any[] = new Array<any>();
    public loading: boolean = true;

    public constructor() {
        for (const verb in OcbHttpVerbs) {
            if (isNaN(Number(verb))) {
                this.verbs.push({ name: verb, id: OcbHttpVerbs[verb] });
            }
        }
        this.loading = false;
    }

    public onSelectedItemChange($event: { name: string, id: string }) {
        if ($event == null) {
            return;
        }
        this.selectedItemChange.emit($event.id);
    }
}
